"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.finishExperiment = finishExperiment;
const taskSetup_1 = require("../../taskSetup");
const helpers_1 = require("../helpers");
const __1 = require("../../..");
const taskStore_1 = require("../../../taskStore");
const utils_1 = require("../../../utils");
function finishExperiment() {
    const t = (0, taskStore_1.taskStore)().translations;
    setTimeout(() => {
        const removeDOMElements = (event) => {
            var _a;
            if (event.type === 'click') {
                const buttonId = (_a = event.target) === null || _a === void 0 ? void 0 : _a.id;
                if (buttonId === 'exit-button') {
                    document.body.innerHTML = '';
                    (0, taskStore_1.taskStore)('taskComplete', true);
                    window.removeEventListener('click', removeDOMElements);
                    window.removeEventListener('keydown', removeDOMElements);
                }
            }
            else if (event.type === 'keydown') {
                document.body.innerHTML = '';
                (0, taskStore_1.taskStore)('taskComplete', true);
                window.removeEventListener('keydown', removeDOMElements);
                window.removeEventListener('click', removeDOMElements);
            }
        };
        window.addEventListener('click', removeDOMElements);
        window.addEventListener('keydown', removeDOMElements);
        const logger = utils_1.Logger.getInstance();
        logger.capture('Task Aborted', {
            taskName: (0, taskStore_1.taskStore)().task,
            taskFinished: (0, taskStore_1.taskStore)().taskComplete,
        });
    }, 50); // delay so that previous key presses are not captured
    taskSetup_1.jsPsych.endExperiment(`<div class='lev-stimulus-container'>
            <div class='lev-row-container instruction'>
                <h1>${t.taskFinished}</h1>
            </div>
            <footer>${t.generalFooter}</footer>
            <button id="exit-button" class="primary" style=margin-top:5%>Exit</button>
        </div>`, helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.taskFinished));
}
